import React from "react";
import { CalendarCheck2 } from "lucide-react";
import { BOOKING_URL } from "../mock/mock";

export default function BookCTA() {
  return (
    <section className="py-20 px-6 bg-forge-cream">
      <div className="max-w-3xl mx-auto text-center">
        <h3 className="font-serif text-3xl md:text-4xl text-forge-navy">Ready to Book?</h3>
        <hr className="forge-divider" />
        <p className="text-forge-navy/70 mb-8">Cymyran Terrace townhouses and Newry Street are bookable now — check dates and rates</p>
        <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="btn-navy">
          <CalendarCheck2 size={16} /> Check Availability
        </a>
      </div>
    </section>
  );
}
